module.exports = __webpack_public_path__ + "static/11-man-bike-dca966274c8e327961fdcff7b6d2b81f.png";